export const ADD_ERROR_LOG = 'ADD_ERROR_LOG'
export const ADD_SYSTEM_CONFIG = 'ADD_SYSTEM_CONFIG'
export const ADD_PRODUCT_LINE = 'ADD_PRODUCT_LINE'
export const ADD_EXPIRE_DAY = 'ADD_EXPIRE_DAY'
